export default "__VITE_ASSET__a28191e6__"